module.exports = __webpack_public_path__ + "assets/8b60696e4eef12ca639d945a462623ac.png";